import React, { Component } from "react";
import { applyDataTable } from '../../../custom/dataTable';
import Edit from '../../../../assets/img/svg/edit.svg';
import Delete from '../../../../assets/img/svg/delete.svg';
import FilterIcon from '../../../../assets/img/svg/FilterIcon.svg'
import del from "../../../../assets/img/svg/Del.svg";
import Autocomplete from "react-autocomplete"
import $ from 'jquery';
import withRouter from "../../../custom/withRouter";
import { connect } from "react-redux";
import styles from "../../../../assets/jss/customStyle";
import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import moment from "moment"
import axios from "axios";
import API from "../../../../_helpers/endpointService";
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { CssTextField, CssTextFieldLast } from "../../../custom/textField"

class ShipMaster extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isMobile: false,
            dataList: [],
            Doc_List: [],
            DocFocus: false,
            NameError: false,
            name: "",
            nameError: false,
            section: "",
            showrow: false,
            UserRole: "",
            DeleteId: 0,
            Pagination: {
                "TotalPages": 0
            },
            TypeId: 0,
            searchData: {
                ProjectId: 0,
                Typeid: 0,
                isMasterData: true,
                PageNumber: 1,
                PageSize: 100,
            },
            newpostdata: {
                "ProjectId": 0,
                "TypeId": 0,
                "LookupName": "",
                "Section": "",
                "CreatedBy": "",
                "ModifiedBy": ""
            },
            newpostdocdata: {
                "ProjectId": 0,
                "Id": 0,
                "TypeId": 0,
                "LookupName": "",
                "Section": "DocumentName",
                "CreatedBy": "",
                "ModifiedBy": ""
            },
            postdataname: {
                "Id": 0,
                "Name": "",
                "Section": "",
                "Comments": "",
                "Status": "",
            },
            HoverId: 0,
            FocusId: 0,
            FocusDocId: 0,
            HoverDocId: 0,
        }
    }

    componentDidMount() {
        const { dispatch } = this.props;
        this.getTypes("DocumentTypes")
        this.state.searchData.ProjectId = parseInt(localStorage.getItem("DashId"));
        this.state.newpostdata.ProjectId = parseInt(localStorage.getItem("DashId"));
        this.state.newpostdata.CreatedBy = localStorage.getItem("UserRoles");
        this.state.newpostdata.ModifiedBy = localStorage.getItem("UserRoles");
        this.state.UserRole = localStorage.getItem("UserRoles");
        this.state.newpostdocdata.ProjectId = parseInt(localStorage.getItem("DashId"));
        this.state.newpostdocdata.CreatedBy = localStorage.getItem("UserRoles");
        this.state.newpostdocdata.ModifiedBy = localStorage.getItem("UserRoles");
        this.setState({})
        this.interval = setInterval(() => {
            this.resize()
        }, 10);
    }

    getTypes = (data) => {
        let apiUrl = API.LOOKUP_DATA + '/type?type=' + data;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                if (response?.status === 200) {
                    if (response.data.length > 0) {
                        let type = response.data.filter((val) => val.Name == "TrainingModule")
                        this.state.searchData.Typeid = type[0].Id;
                        this.state.newpostdata.TypeId = type[0].Id;
                        this.state.newpostdocdata.TypeId = type[0].Id;
                        this.state.TypeId = type[0].Id;
                        this.setState({})
                    }
                    this.dataTable(this.state.searchData)
                    // this.requirement(this.state.newpostdata)
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    dataTable = (data) => {
        let apiUrl = API.GET_DOCUMENTSNAME + '?ProjectId=' + data.ProjectId + '&Typeid=' + data.Typeid + '&isMasterData=' + data.isMasterData + '&PageNumber=' + data.PageNumber + '&PageSize=' + data.PageSize;
        // this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    // this.state.Pagination.TotalPages = response.data.Pagination.TotalPages;
                    this.state.dataList = [];
                    this.state.Doc_List = [];
                    {
                        response.data?.Data && response.data?.Data.map((a) => (
                            a.Items && a.Items.map((s) => (
                                s.Section == "" ?
                                    this.state.dataList.push(s) : ""
                            ))
                        ))
                    }
                    {
                        response.data?.Data && response.data?.Data.map((a) => (
                            a.Items && a.Items.map((s) => (
                                s.Section == "DocumentName" ?
                                    this.state.Doc_List.push(s) : ""
                            ))
                        ))
                    }
                    this.setState({})
                    if (Object(this.state.Doc_List).length == 0) {
                        // this.post_data1(this.state.newpostdocdata)
                        this.state.Doc_List.push(this.state.newpostdocdata)
                        // this.state.Doc_List.push(
                        //     {
                        //         "ProjectId": localStorage.getItem("DashId"),
                        //         "TypeId": this.state.TypeId,
                        //         "LookupName": "",
                        //         "Section": "DocumentName",
                        //         "CreatedBy": localStorage.getItem("UserRoles"),
                        //         "ModifiedBy": localStorage.getItem("UserRoles")
                        //     }
                        // )
                    }
                    this.setState({})
                    this.state.dataList.push({
                        Comments: null,
                        Id: 0,
                        Name: "",
                        Section: "",
                        Status: null
                    })
                    this.setState({})
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    postDataChange = (e, val) => {
        if (val == "Name") {
            this.state.name = e.target.value;
            if (e.target.value.trim() != "") {
                this.state.showrow = true;
            }
            if (e.target.value.trim() != "") {
                this.state.nameError = true;
            }
        }
        if (val == "Section") {
            this.state.section = e.target.value;
        }
        this.setState({})
    }

    postDataBlur = (e, i, val) => {
        if (val == "Name") {
            if (e.target.value.trim() != "") {
                this.state.newpostdata.LookupName = e.target.value.trim();
                this.setState({})
                this.post_data(this.state.newpostdata)
            }
            if (this.state.name.trim() == "" && this.state.nameError == true) {
                this.state.showrow = false;
                this.state.nameError = false;
                this.state.name = "";
                this.state.section = "";
                this.setState({})
            }
        }
        if (val == "Section") {
            this.state.section = e.target.value;
        }
        this.setState({})
    }

    requirement = (data) => {
        let apiUrl = API.LOOKUP_DATA + '/ProjectLookups';
        // this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "POST",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                // this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {

                } else {
                }
            })
            .catch((error) => {
                // this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    componentWillUnmount() {
        clearInterval(this.interval);
        $("#PROMAS3 .MuiListItemText-primary").addClass("spanTopBar")
        $("#Promaster3 .MuiListItemText-primary").removeClass("fw-bolder");
        $("#Promaster33").addClass("d-none");
        $("#Promaster33").removeClass("d-block");
        // $("#MOPA").removeClass("active-color");
        // $("#MOPAT").removeClass("fw-bolder");
        this.props.dispatch({ type: "LOOKUP_DATAS", data: [] });
    }

    sidebar = () => {
        this.props.navigate("/sidebarprojectmasterdata");
    }

    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }
        $("#PROMAS3 .MuiListItemText-primary").addClass("spanTopBar")
        $("#Promaster3 .MuiListItemText-primary").addClass("fw-bolder");
        $("#Promaster33").removeClass("d-none");
        $("#Promaster33").addClass("d-block");
        // $("#MOPAT .MuiListItemText-primary").addClass("fw-bolder")
        // $("#MOPA").addClass("active-color")
    };

    post_data1 = (data) => {
        let apiUrl = API.LOOKUP_DATA + '/ProjectLookups';
        axios({
            method: "POST",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.state.Doc_List.map((i) => (
                        i.Id == 0 ? i.Id = response.data : <></>
                    ))
                    this.setState({})
                } else {
                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    post_data = (data) => {
        let apiUrl = API.LOOKUP_DATA + '/ProjectLookups';
        axios({
            method: "POST",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.state.nameError = false;
                    this.state.name = "";
                    this.state.section = "";
                    this.state.dataList.map((i) => (
                        i.Id == 0 ? i.Id = response.data : <></>
                    ))
                    this.setState({})
                    this.state.actNameFocus = false;
                    document.getElementById("actName" + response.data).focus()
                    this.state.showrow = false;
                    let id = this.state.dataList.filter((i) => i.Id == 0)
                    if (id.length == 0) {
                        this.state.dataList.push({
                            Comments: null,
                            Id: 0,
                            Name: "",
                            Section: "",
                            Status: null
                        })
                    }
                    // this.state.dataList.sort((a, b) => {
                    //     return a.Id - b.Id;
                    // });
                    this.setState({})
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    put_data = (data) => {
        let apiUrl = API.LOOKUP_DATA + '/UpdateProjectLookupField';
        // this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "PUT",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                // this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                } else {
                }
            })
            .catch((error) => {
                // this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    OpenPopup = (Id) => {
        this.state.DeleteId = Id;
        this.setState({})
        window.$("#deletepopup").modal("show")
    }

    DeleteItem = () => {
        window.$("#deletepopup").modal("hide");
        this.deleteopalookdocs(this.state.DeleteId)
    }

    deleteopalookdocs = (data) => {
        let apiUrl = API.LOOKUP_DATA + '/RemoveProjectLookups?projectLookupId=' + data;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "POST",
            url: apiUrl,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.dataTable(this.state.searchData)
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {

                }
            });
    };

    BackPage = () => {
        this.state.searchData.PageNumber = this.state.searchData.PageNumber - 1;
        this.setState({})
        this.dataTable(this.state.searchData)
    }

    NextPage = () => {
        this.state.searchData.PageNumber = this.state.searchData.PageNumber + 1;
        this.setState({})
        this.dataTable(this.state.searchData)
    }

    handleInputChangeRequire = (e, str, val, index) => {
        if (val == "Name") {
            this.state.dataList.map((i) => (
                i.Id == str.Id ? i.Name = e.target.value : ""
            ))
            if (str.Id == 0 && e.target.value.length == 1 && e.target.value.trim() != "") {
                this.state.newpostdata.LookupName = e.target.value;
                this.setState({});
                this.post_data(this.state.newpostdata)
                this.state.actNameFocus = true
            }
            if (e.target.value.trim() == "" && str.Id != 0) {
                this.state.index = str.Id;
                this.setState({})
                document.getElementById("actName" + str.Id).focus();
            }
            if (str.Id == 0 && str.Name.trim() != "") {
                this.state.showrow = true;
                this.state.autoFocus = true;
                this.state.nameError = true;
                // this.state.selectionStart = this.inputRef.current.selectionStart;
                // var el = document.getElementById('docName');
                // el.value = e.target.value;
                // el.focus();
                // if (typeof el.selectionStart == "number") {
                //     el.selectionStart = el.selectionEnd = e.target.value.length;
                // } else if (typeof el.createTextRange != "undefined") {           
                //     var range = el.createTextRange();
                //     range.collapse(false);
                //     range.select();
                // }
                // ele.setSelectionRange(e.target.value.length, e.target.value.length);
                // var len = e.target.value.length+1;
                // document.getElementById("docName").focus();
                // document.getElementById("docName").setSelectionRange(len, len);
            }
        }
        this.setState({})
    }

    handleInputChangeRequireBlur = (e, str, val) => {
        if (str.Name.trim() == "") {
            this.deleteopalookdocs(str.Id)
        }
        if (str.Name.trim() != "") {
            let data = {
                Comments: str.Comments == null ? "" : str.Comments,
                Id: str.Id,
                Name: str.Name.trim(),
                Section: "",
                Status: null
            }
            this.put_data(data)
            this.state.autoFocus1 = false;
            this.setState({})
        }
        if (val == "Name") {
            this.state.dataList.map((i) => (
                i.Id == str.Id ? i.Name = e.target.value.trim() : ""
            ))
        }
        if (val == "Section") {
            this.state.dataList.map((i) => (
                i.Id == str.Id ? i.Section = e.target.value.trim() : ""
            ))
        }
        this.setState({})
    }

    handleFocusNameChange = (e, str, val) => {
        this.setState({ index: str.Id })
        if (e.target.value.trim().length > 0) {
            document.getElementById("actName" + str.Id).selectionStart = e.target.value.trim().length;
            document.getElementById("actName" + str.Id).focus()
        }
    }

    handleFocusDocChange = (e, str, val) => {
        if (e.target.value.trim().length > 0) {
            document.getElementById("DocFocus").selectionStart = e.target.value.trim().length;
            document.getElementById("DocFocus").focus()
        }
    }

    handleFocusActChange = (e, str, val) => {
        this.setState({ actNameFocus: true, index: str.Id })
        if (str.Id == 0 && e.target.value.trim().length > 0) {
            document.getElementById('actName').selectionStart = e.target.value.trim().length;
            document.getElementById('actName').focus()
        }
    }

    handleInputChange = (e, str, val) => {
        this.state.Doc_List.map((i) => (
            i.Id == str.Id ? i.Name = e.target.value : ""
        ))
        this.setState({})
        if (e.target.value.trim() != "") {
            this.state.NameError = false;
            this.setState({})
        }
        else {
            this.state.NameError = true;
            this.setState({})
        }
        this.state.DocFocus = true;
        this.setState({})
    }

    handleInputChange4 = (e, str) => {
        if (str.Id == 0) {
            this.state.newpostdocdata.LookupName = e.target.value.trim();
            this.setState({})
            this.post_data1(this.state.newpostdocdata)
        } else {
            let data = {
                Comments: str.Comments,
                Id: str.Id,
                Name: e.target.value.trim(),
                Section: str.Section,
                Status: null
            }
            this.put_data(data)
        }
        this.state.Doc_List.map((i) => (
            i.Id == str.Id ? i.Name = e.target.value.trim() : ""
        ))
        if (str.Name.trim() == "") {
            this.state.NameError = false;
        }
        this.state.DocFocus = false;
        this.setState({})
    }

    handleInputChange1 = (e, str, val) => {
        str.Name = str.Name.trim();
        this.put_data(str)
        this.state.dataList.map((i) => (
            i.Id == str.Id ? i.Name = e.target.value.trim() : ""
        ))
        this.setState({})
    }

    handleInputChange2 = (e, str, val) => {
        if (val == "Name") {
            this.state.dataList.map((i) => (
                i.Id == str.Id ? i.Name = e.target.value : ""
            ))
            if (str.Id == 0 && str.Name.trim() != "") {
                this.state.showrow = true;
                this.state.nameError = true;
                this.setState({})
            }
            this.setState({})
        }
        if (val == "Section") {
            this.state.dataList.map((i) => (
                i.Id == str.Id ? i.Section = e.target.value : ""
            ))
            this.setState({})
        }
        // if (this.state.dataList[this.state.dataList.length - 1].Name != "") {
        //     this.state.showrow = true;
        //     this.setState({})
        // }
    }

    handleInputChange3 = (e, str, val) => {
        if (str.Name.trim() == "") {
            this.deleteopalookdocs(str.Id)
        }
        if (str.Name.trim() != "") {
            this.put_data(str)
        }
        // // if (str.Name != "") {
        // this.put_data(str)
        // // }
        // if (str.Name == "") {
        // }
        // if (this.state.showrow == true) {
        //     this.post_data(this.state.newpostdata)
        //     // this.state.showrow = false;
        //     // this.setState({})
        // }
    }

    render() {
        let { classes, menuToggle } = this.props;
        return (
            <>
                {this.state.isMobile ?
                    <>
                        <div className="row w-100 border-bottom mt-4">
                            <div className="col-6 mt-auto">
                                <List className="pt-3 mt-4 pl-3" style={{ backgroundColor: "#F6F6F6" }}>
                                    <ListItem onClick={() => this.sidebar()} >
                                        <ListItemText id="PROMAS3" className='  textNaviIcon' primary="Master Data" />
                                        <NavigateNextIcon id="PROMAS33" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                        <Divider className='border-bottom' />
                                    </ListItem>
                                </List>
                            </div>
                            <div className="col-6 pt-2 mt-5 ">
                                <h4>Training Module</h4>
                            </div>
                        </div>
                    </>
                    :
                    <></>
                }
                <div className="ml-auto" style={{ overflowX: "hidden", backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -95 }}>
                    <div className="row" style={{ margin: this.state.isMobile ? "auto" : "5px" }}>
                        <div className="row px-3">
                            <div className="col-10 p-2">
                                {this.state.isMobile ? <></> : <h6>Training Module</h6>}
                            </div>
                        </div>
                        <div className="col-12 col-lg-12 col-md-12 col-sm-12 col-xl-12">
                            <div className="table-responsive" style={{ width: "100%" }}>
                                <table id="DocsTable" className="table table-borderless border-top border-bottom border-left border-right">
                                    <thead>
                                        <tr className="table-active">
                                            <th className="border-top border-right border-left" width="100%" style={{ minWidth: '100%', maxWidth: '100%' }}><span className="spandoc-thead" style={{ color: "#000000" }}>Document Name</span></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.Doc_List && this.state.Doc_List.map((i, index) => (
                                            <tr className="border-top" onMouseEnter={() => this.setState({ HoverDocId: i.Id })} onMouseLeave={() => this.setState({ HoverDocId: 0 })}>
                                                <td className="align-middle border-right border-left docname-set" style={{ minWidth: '97%', maxWidth: '97%' }}>
                                                    {(i.Name == "" && this.state.newpostdocdata.LookupName == "") ?
                                                        <CssTextFieldLast
                                                            multiline
                                                            fullWidth
                                                            variant="outlined"
                                                            type="text"
                                                            autoFocus={this.state.DocFocus}
                                                            id="DocFocus"
                                                            onFocus={(e) => this.handleFocusDocChange(e, i)}
                                                            onChange={(e) => this.handleInputChange(e, i)}
                                                            onBlur={(e) => this.handleInputChange4(e, i)}
                                                            value={i.Name}
                                                            InputProps={{
                                                                className: `border-radius padding-space spandoc-tbody ${classes.inputfieldAlign}`
                                                            }} />
                                                        : <CssTextField
                                                            multiline
                                                            fullWidth
                                                            variant="outlined"
                                                            type="text"
                                                            autoFocus={this.state.DocFocus}
                                                            id="DocFocus"
                                                            onFocus={(e) => this.handleFocusDocChange(e, i)}
                                                            onChange={(e) => this.handleInputChange(e, i)}
                                                            onBlur={(e) => this.handleInputChange4(e, i)}
                                                            value={i.Name}
                                                            InputProps={{
                                                                className: `border-radius padding-space spandoc-tbody ${classes.inputfieldAlign}`
                                                            }} />}
                                                    {(this.state.NameError == true) ?
                                                        <span className="pt-5" style={{ color: '#DD0000' }}>Document Name is required</span> : <></>}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="row px-3">
                            <div className="col-10 p-2">
                                {this.state.isMobile ? <></> : <h6>Training Requirements List</h6>}
                            </div>
                        </div>
                        <div className="col-12 col-lg-12 col-md-12 col-sm-12 col-xl-12">
                            <div className="table-responsive" style={{ width: "100%" }}>
                                <table id="DocsTable" className="table table-borderless border-top border-bottom border-left border-right">
                                    <thead>
                                        <tr className="table-active">
                                            <th className="border-top border-right border-left" width="97%" style={{ minWidth: '97%', maxWidth: '97%' }}><span className="spandoc-thead" style={{ color: "#000000" }}>Requirement Lists</span></th>
                                            <th className="border-top border-right" onClick={() => this.setState({ content: !this.state.content })} width="3%" style={{ minWidth: '3%', maxWidth: '3%' }}><span className="fw-bold" style={{ color: "#000000" }}>Action</span></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state?.dataList && this.state?.dataList.map((i, index) => (
                                            i.Id != 0 ?
                                                <tr className="border-top">
                                                    <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-right border-left`} style={{ minWidth: '49%', maxWidth: '49%' }}>
                                                        {(i.Name == "") ?
                                                            <CssTextFieldLast
                                                                multiline
                                                                fullWidth
                                                                variant="outlined"
                                                                type="text"
                                                                autoFocus={this.state.index == i.Id ? true : false}
                                                                id={"actName" + i.Id}
                                                                onFocus={(e) => this.handleFocusNameChange(e, i, 'Name')}
                                                                onChange={(e) => this.handleInputChangeRequire(e, i, 'Name', index)}
                                                                onBlur={(e) => this.handleInputChangeRequireBlur(e, i, 'Name')}
                                                                value={i.Name}
                                                                InputProps={{
                                                                    className: `border-radius padding-space spandoc-tbody ${classes.inputfieldAlign}`
                                                                }} /> :
                                                            <CssTextField
                                                                multiline
                                                                fullWidth
                                                                variant="outlined"
                                                                type="text"
                                                                autoFocus={this.state.index == i.Id ? true : false}
                                                                id={"actName" + i.Id}
                                                                onFocus={(e) => this.handleFocusNameChange(e, i, 'Name')}
                                                                onChange={(e) => this.handleInputChangeRequire(e, i, 'Name', index)}
                                                                onBlur={(e) => this.handleInputChangeRequireBlur(e, i, 'Name')}
                                                                value={i.Name}
                                                                InputProps={{
                                                                    className: `border-radius padding-space spandoc-tbody ${classes.inputfieldAlign}`
                                                                }} />}
                                                        {(i.Name == "") ?
                                                            <span className="pt-5" style={{ color: '#DD0000' }}>Requirement List is required</span> : <></>}
                                                    </td>
                                                    <td className="align-middle text-center border-right"><img src={Delete} className="cursorPointer" onClick={() => { this.OpenPopup(i.Id) }} /></td>
                                                </tr> : <></>
                                        ))}
                                        {this.state?.dataList && this.state?.dataList.map((i) => (
                                            i.Id == 0 ?
                                                <tr className="border-top">
                                                    <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-right border-left`} style={{ minWidth: '49%', maxWidth: '49%' }}>
                                                        {(i.Name == "") ?
                                                            <CssTextFieldLast
                                                                multiline
                                                                fullWidth
                                                                variant="outlined"
                                                                type="text"
                                                                id="actName"
                                                                autoFocus={this.state.actNameFocus}
                                                                onFocus={(e) => this.handleFocusActChange(e, i, 'Name')}
                                                                onChange={(e) => this.handleInputChangeRequire(e, i, 'Name')}
                                                                onBlur={(e) => this.postDataBlur(e, i, 'Name')}
                                                                onPaste={(e) => this.handlePasteChange(e, i, 'Name')}
                                                                value={i.Name}
                                                                InputProps={{
                                                                    className: `border-radius padding-space spandoc-tbody ${classes.inputfieldAlign}`
                                                                }} /> :
                                                            <CssTextField
                                                                multiline
                                                                fullWidth
                                                                variant="outlined"
                                                                type="text"
                                                                id="actName"
                                                                autoFocus={this.state.actNameFocus}
                                                                onFocus={(e) => this.handleFocusActChange(e, i, 'Name')}
                                                                onChange={(e) => this.handleInputChangeRequire(e, i, 'Name')}
                                                                onPaste={(e) => this.handlePasteChange(e, i, 'Name')}
                                                                onBlur={(e) => this.postDataBlur(e, i, 'Name')}
                                                                value={i.Name}
                                                                InputProps={{
                                                                    className: `border-radius padding-space spandoc-tbody ${classes.inputfieldAlign}`
                                                                }} />}
                                                        {((i.Name.trim() == "" && this.state.nameError == true) || (i.Name.trim() == "" && i.Section.trim() != "")) ?
                                                            <span className="pt-5" style={{ color: '#DD0000' }}>Requirement List is required</span> : <></>}
                                                    </td>
                                                    <td className="align-middle text-center border-right">
                                                        {(i.Name.trim() != "" || (i.Name.trim() == "" && this.state.nameError == true)) ? <img src={Delete} className="cursorPointer" /> : <></>}
                                                    </td>
                                                </tr> : <></>
                                        ))}
                                        {this.state.showrow ?
                                            <tr className="border-top">
                                                <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-right border-left`} style={{ minWidth: '49%', maxWidth: '49%' }}>
                                                    <CssTextFieldLast
                                                        type="text"
                                                        variant="outlined"
                                                        fullWidth
                                                        multiline
                                                        size="small"
                                                        InputProps={{
                                                            className: `border-radius padding-space spandoc-tbody ${classes.inputfieldAlign}`
                                                        }}
                                                    />
                                                </td>
                                                <td className="align-middle text-center border-right">
                                                </td>
                                            </tr> : ""}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade p-5 mt-5" id="deletepopup" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">Are you sure you want to delete?</h5></div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={() => this.DeleteItem()}><span className="" >Delete</span></button>
                                    <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#deletepopup").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        Project_Master: state.ProjectMasterDataReducer.Project_Master,
    };
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ShipMaster))
);
